import styled from 'styled-components';

export const Container = styled.h3`
  color: #1C528B;
`;
